export const BUSINESS = {
  name: "Pastisseria Solís",
  short: "Solís",
  tagline: "Pastisseria artesana a Calella des de 1965",
  address: "Carrer de la Bruguera, 62, 08370 Calella, Barcelona",
  phoneDisplay: "937 69 56 54",
  phoneTel: "+34937695654",
  whatsapp:
    "https://wa.me/34937695654?text=" +
    encodeURIComponent("Hola! M'agradaria rebre més informació sobre els vostres productes."),
  googleReviews:
    "https://www.google.com/search?q=Pastisseria+Sol%C3%ADs+Calella+ressenyes",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("Pastisseria Solís, Carrer de la Bruguera, 62, 08370 Calella"),
  mapEmbed:
    "https://www.google.com/maps?q=" +
    encodeURIComponent("Carrer de la Bruguera, 62, 08370 Calella, Barcelona") +
    "&output=embed",
};

export const IMAGES = {
  storefront:
    "https://customer-assets.emergentagent.com/job_sweet-solis/artifacts/5xz6zv93_ChatGPT%20Image%2029%20jun%202026%2C%2016_33_00.png",
  baker:
    "https://customer-assets.emergentagent.com/job_sweet-solis/artifacts/nmfsfqec_unnamed%20%289%29.webp",
  assorted:
    "https://customer-assets.emergentagent.com/job_sweet-solis/artifacts/w1l2tq86_ChatGPT%20Image%2029%20jun%202026%2C%2016_31_42.png",
  milfulls:
    "https://customer-assets.emergentagent.com/job_sweet-solis/artifacts/8rkemj6m_unnamed%20%288%29.webp",
  display:
    "https://customer-assets.emergentagent.com/job_sweet-solis/artifacts/yrawdvsf_ChatGPT%20Image%2029%20jun%202026%2C%2016_29_05.png",
  bread:
    "https://images.unsplash.com/photo-1778472506771-22d00e974d2f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  croissants:
    "https://images.pexels.com/photos/13736076/pexels-photo-13736076.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const PRODUCTS = [
  { id: "assortit", title: "Pastissets variats", desc: "Selecció de dolços artesans", img: IMAGES.assorted, span: "lg:col-span-7 lg:row-span-2" },
  { id: "milfulls", title: "Milfulls", desc: "Crema i fullatge cruixent", img: IMAGES.milfulls, span: "lg:col-span-5" },
  { id: "brioixeria", title: "Brioixeria i xocolates", desc: "Acabats de fer cada matí", img: IMAGES.display, span: "lg:col-span-5" },
  { id: "pa", title: "Pa artesà", desc: "Elaborat a mà cada dia", img: IMAGES.bread, span: "lg:col-span-4" },
  { id: "croissants", title: "Croissants", desc: "Mantega i tradició", img: IMAGES.croissants, span: "lg:col-span-8" },
];

export const HOURS = [
  { day: "Dilluns", slots: ["8:30 – 13:30", "17:30 – 20:00"] },
  { day: "Dimarts", slots: [], closed: true },
  { day: "Dimecres", slots: ["8:30 – 13:30"] },
  { day: "Dijous", slots: ["8:30 – 13:30", "17:30 – 20:00"] },
  { day: "Divendres", slots: ["8:30 – 13:30", "17:30 – 20:00"] },
  { day: "Dissabte", slots: ["8:30 – 13:45", "17:30 – 20:15"] },
  { day: "Diumenge", slots: ["8:40 – 14:15"] },
];

export const REVIEWS = [
  { name: "Maria Pujol", text: "La millor pastisseria de Calella. Els milfulls són espectaculars i el tracte immillorable." },
  { name: "Jordi Ferrer", text: "Pa acabat de fer cada matí i una brioixeria boníssima. Hi torno cada cap de setmana." },
  { name: "Núria Camps", text: "Fa anys que hi compro els pastissos d'aniversari. Sempre artesans i deliciosos." },
  { name: "Albert Soler", text: "Els croissants de xocolata són els millors que he tastat. Tot fet a mà." },
  { name: "Carme Vidal", text: "Una pastisseria de tota la vida amb productes de qualitat. Molt recomanable!" },
  { name: "David Roca", text: "Atenció excel·lent i dolços espectaculars. Un clàssic de Calella." },
];

export const NAV = [
  { id: "inici", label: "Inici" },
  { id: "sobre-nosaltres", label: "Sobre nosaltres" },
  { id: "productes", label: "Productes" },
  { id: "ressenyes", label: "Ressenyes" },
  { id: "ubicacio", label: "Ubicació" },
  { id: "contacte", label: "Contacte" },
];
